import { SVGProps, Ref, forwardRef } from 'react';

export const FolderHeartFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.37 2c-5.25 0-7 1.75-7 7v.022C2.708 8.564 4.162 8.5 5.564 8.5h12.872c1.365 0 2.776.063 4.085.486C22.068 5.292 20.14 4 15.63 4H12.3l-.8-2zm14.26 8.975c-.898-.479-2.266-.675-4.194-.675H5.564c-1.929 0-3.297.196-4.194.675-1.473.786-1.676 2.333-1 5.025 1.086 4.332 2.806 6 7.9 6 .823 0 1.777.005 2.601.01 1.728.01 3.586.021 5.312-.015a16 16 0 0 1-1.57-1.15c-.963-.816-2.183-2.128-2.183-3.913 0-1.974 1.3-3.48 2.995-3.908 1.12-.283 2.297-.081 3.311.564 1.027-.638 2.21-.814 3.323-.515.725.194 1.389.589 1.904 1.137.164-1.62-.224-2.643-1.333-3.235m-8.4 5.957c0-2.25 2.863-3.223 4.5-.887 1.636-2.336 4.5-1.25 4.5.887 0 1.822-2.478 3.306-4.338 4.42l-.162.098-.162-.097c-1.86-1.115-4.338-2.6-4.338-4.421"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
FolderHeartFilledSize24Glyph.displayName = 'FolderHeartFilledSize24Glyph';
